import { API_URL } from "@/config/api";
import { Check, Eye, Square, X } from "lucide-react";
import React, { act, useEffect, useState } from "react";
import FilterModal from "./FilterModal";
import { useAuth } from "@/hooks/useAuth";
import { CircularProgress } from "@mui/material";
import moment from 'moment';
import { ClientForm } from "../Client";
import ClientsForm from "../Client/ClientsForm";

export default function AppointmentScheduleModal({ open, onClose, clients, products, users, roles, affiliates, appointments,onData }) {
  if (!open) return null;

  const clientes = clients?.data ?? [];
  const { user } = useAuth();

  const [selecionado, setSelecionado] = useState(null);
  const [product, setProduct] = useState(null);

  const [search, setSearch] = useState('');
  const [activity, setActivity] = useState(null);

  const [etapa, setEtapa] = useState(0);
  const [fluxo, setFluxo] = useState("guiado");
  const [activities, setActivities] = useState([]);

  const [clients_products, setClientProducts] = useState([]);
  const [selectedAgenda, setSelectedAgenda] = useState("Pessoal");

  const [selectedProfissional, setSelectedProfissional] = useState(null);

  const [open_filter, setOpenFilter] = useState(false);

  const [selectedSetor, setSelectedSetor] = useState('all');
  const [selectedArea, setSelectedArea] = useState('all');
  const [selectedRole, setSelectedRole] = useState('all');
  const [dayCalendar, setDayCalendar] = useState(null);
  const [timeSelect,setTime]=useState(null);

  const [schedules,setSchedules]=useState([]);
  const [schedules_user,setSchedulesUser]=useState([]);
  const [schedules_profissional,setSchedulesProfissional]=useState([]);

  const [selectTab,setSelectTab] = useState(0);




  const hoje = new Date();
  const [mesAtual, setMesAtual] = useState(hoje.getMonth());
  const [anoAtual, setAnoAtual] = useState(hoje.getFullYear());

  const [loadingSave,setLoadingSave] = useState(false);
  const [hours,setHours] = useState({});


  // Retorna matriz com as semanas do mês
  function gerarDiasMes(mes, ano) {
    const primeiroDia = new Date(ano, mes, 1);
    const ultimoDia = new Date(ano, mes + 1, 0);

    const dias = [];
    let linha = [];

    // preencher dias vazios antes do primeiro dia
    for (let i = 0; i < primeiroDia.getDay(); i++) {
      linha.push(null);
    }

    // preencher dias do mês
    for (let d = 1; d <= ultimoDia.getDate(); d++) {
      linha.push(d);
      if (linha.length === 7) {
        dias.push(linha);
        linha = [];
      }
    }

    // completar a última linha
    if (linha.length > 0) dias.push(linha);

    return dias;
  }

  const semanas = gerarDiasMes(mesAtual, anoAtual);

  function mudarMes(offset) {
    let novoMes = mesAtual + offset;
    let novoAno = anoAtual;

    if (novoMes > 11) {
      novoMes = 0;
      novoAno++;
    }
    if (novoMes < 0) {
      novoMes = 11;
      novoAno--;
    }

    setMesAtual(novoMes);
    setAnoAtual(novoAno);
  }

  const meses = [
    "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
    "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
  ];


  function gerarReunioes(inicio, fim, duracaoMin) {
    console.log(inicio,fim,duracaoMin)
    const resultados = [];

    // Converte "HH:MM" para minutos totais
    const paraMinutos = (h) => {
      const [hora, minuto] = h.split(":").map(Number);
      return hora * 60 + minuto;
    };

    // Converte minutos totais para "HH:MM"
    const paraHora = (m) => {
      const h = String(Math.floor(m / 60)).padStart(2, "0");
      const min = String(m % 60).padStart(2, "0");
      return `${h}:${min}`;
    };

    let atual = paraMinutos(inicio);
    const limite = paraMinutos(fim);

    while (atual + duracaoMin <= limite) {
      const inicioReuniao = atual;
      const fimReuniao = atual + duracaoMin;

      resultados.push({
        inicio: paraHora(inicioReuniao),
        fim: paraHora(fimReuniao),
      });

      atual = fimReuniao; // Próxima reunião
    }
    console.log('resultados', resultados)


    return resultados;
  }


  const saveSchedule = (e:any)=>{
    setLoadingSave(true);
    let users_=[user?._id];
    if(selectedProfissional){
      users_.push(selectedProfissional);
    }
      fetch(API_URL + '/appointments/schedules_create', {
                method:'POST',
                  headers: {
                    "Authorization": localStorage.getItem('token'),
                    "Accept": "application/json",
                    "Content-type": "application/json"
                  },
                  body:JSON.stringify({
                    inicio:dayCalendar?.ano+'-'+dayCalendar.mes+'-'+dayCalendar.dia+' '+timeSelect.inicio+':00',
                    fim:dayCalendar?.ano+'-'+dayCalendar.mes+'-'+dayCalendar.dia+' '+timeSelect.fim+':00',
                    clientId:selecionado,
                    users:users_,
                    appointmentId:activity?.appointment?._id

                  })
                }).then(async(data)=>{
                  let resp = await data.json();
                  console.log(resp)
    setLoadingSave(false);
                  onClose();
                }).catch((e)=>{
                  console.log(e);
    setLoadingSave(false);

                })
    }





  useEffect(() => {
    let activities: any = [];
    console.log(product);
    if (product != null) {
      product?.phases?.map((item: any) => {
        item.activities.map((item2: any) => {
          let appointment = appointments.filter((item3) => item3.activity == item2._id)[0];
          if (appointment && appointment?.userPoolIndividual?.users?.includes(user?._id)) {
            activities.push({ ...item2, appointment });
          }
        })
      })
    }
    setActivities(activities);
  }, [product]);




  return (
    <div className="fixed inset-0 bg-black/50 flex justify-center p-4 z-50">
      {etapa == 0 && <div className="bg-white w-1/2 h-full rounded-xl shadow-lg p-6 overflow-y-auto relative">

        {/* Header */}
        <div className="flex justify-between items-center">
          <h2 className="text-2xl font-bold">Novo agendamento</h2>
          <button onClick={onClose} className="text-gray-600 text-xl">✕</button>
        </div>

        <h3 className="text-center text-xl font-semibold mt-4">Cliente</h3>
        <p className="text-center text-gray-500">Selecione um cliente para continuar</p>

        {/* Tabs */}
        <div className="flex items-center justify-center gap-2 mt-6">
          <div className="h-1 w-20 bg-blue-500 rounded-full"></div>
          <div className="h-1 w-20 bg-gray-200 rounded-full"></div>
          <div className="h-1 w-20 bg-gray-200 rounded-full"></div>
          <div className="h-1 w-20 bg-gray-200 rounded-full"></div>
          <div className="h-1 w-20 bg-gray-200 rounded-full"></div>
          <div className="h-1 w-20 bg-gray-200 rounded-full"></div>
          <div className="h-1 w-20 bg-gray-200 rounded-full"></div>

        </div>
        <div className="flex mt-6 border-b">
          <button onClick={(e)=>{
            setSelectTab(0);
          }} className={selectTab==0? "px-6 py-2 border-b-2 border-blue-600 text-blue-600 font-semibold":"px-6 py-2 text-gray-400"}>Selecionar</button>
          <button onClick={(e)=>{
            setSelectTab(1);
          }} className={selectTab==1? "px-6 py-2 border-b-2 border-blue-600 text-blue-600 font-semibold":"px-6 py-2 text-gray-400"}>Criar contato</button>
        </div>

        {/* Search */}
        {selectTab==0 && <>
        <input
          type="text"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
          }}
          placeholder="pesquise por nome ou whatsapp"
          className="w-full mt-4 border px-4 py-2 rounded-lg"
        />
        {/* Nenhum */}
        {/* <label className="flex items-center gap-3 mt-4">
          <input
            type="radio"
            name="cliente"
            checked={selecionado === "nenhum"}
            onChange={() => setSelecionado("nenhum")}
          />
          <span className="text-gray-600">Nenhum</span>
        </label> */}

        {/* Lista de clientes */}
        <div className="mt-6 space-y-6 scrollbar-hide" style={{ maxHeight: '55vh', overflow: 'scroll' }}>
          {clientes.filter((item) => item.name?.includes(search)).map((c, i) => (
            <label key={i} className="flex items-center gap-4 cursor-pointer">
              <input
                type="radio"
                name="cliente"
                checked={selecionado === c._id}
                onChange={() => setSelecionado(c._id)}
              />
              <img src={c.im.includes('https') ? c.im : 'https://microbiology.ucr.edu/sites/default/files/styles/form_preview/public/blank-profile-pic.png?itok=4teBBoet'} alt="Foto" className="rounded-md w-12 h-12 object-cover" />
              <div>
                <p className="font-semibold">{c.name}</p>
                <p className="text-gray-500 text-sm">{c.whatsapp}</p>
              </div>
            </label>
          ))}
        </div>

        </>}
        
        {selectTab==1 &&<ClientsForm onClose={()=>{
          onData();
          setSelectTab(0);
        }} />}

        {/* Footer */}
        {selectTab==0 && <div className="flex justify-end mt-2 pb-6 " style={{ position: 'absolute', bottom: 0, right: 20, left: 20 }}>
          {/* <button className="px-6 py-3 rounded-lg border text-gray-600">Voltar</button> */}
          <button onClick={async (e) => {
            if (selecionado == null) {
              return;
            }
            let clients_products = await (await fetch(API_URL + '/clients/get_client_products?client_id=' + selecionado, {
              headers: {
                "Authorization": localStorage.getItem('token'),
                "Accept": "application/json"
              }
            })).json()
            console.log(clients_products)
            setClientProducts(clients_products?.data);
            setSearch('');

            setEtapa(1);
          }} className={"px-6 py-3 rounded-lg  text-white  " + (selecionado == null ? 'opacity-70 cursor-not-allowed bg-gray-300' : 'bg-blue-500 hover:bg-blue-600')}>
            Próximo
          </button>
        </div>}

      </div>}
      {etapa == 1 && <div className="bg-white w-1/2 h-full rounded-xl shadow-lg p-6 overflow-y-auto relative">

        {/* HEADER */}
        <div className="flex justify-between items-center">
          <h2 className="text-2xl font-bold">Novo agendamento</h2>
          <button onClick={onClose} className="text-gray-600 text-xl">✕</button>
        </div>

        {/* Título */}
        <h3 className="text-center text-xl font-semibold mt-4">Produto</h3>
        <p className="text-center text-gray-500">
          Selecione um produto para continuar
        </p>

        {/* Barra de progresso */}
       <div className="flex items-center justify-center gap-2 mt-6">
          <div className="h-1 w-20 bg-blue-500 rounded-full"></div>
          <div className="h-1 w-20 bg-blue-500 rounded-full"></div>
          <div className="h-1 w-20 bg-gray-200 rounded-full"></div>
          <div className="h-1 w-20 bg-gray-200 rounded-full"></div>
          <div className="h-1 w-20 bg-gray-200 rounded-full"></div>
          <div className="h-1 w-20 bg-gray-200 rounded-full"></div>
          <div className="h-1 w-20 bg-gray-200 rounded-full"></div>

        </div>

        {/* Campo de busca */}
        <input
          type="text"
          placeholder="pesquise por nome ou whatsapp"
          className="w-full mt-6 border px-4 py-2 rounded-lg"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        {/* "Nenhum" */}
        {/* <label className="flex items-center gap-3 mt-4 text-gray-700 cursor-pointer">
          <input
            type="radio"
            name="produto"
            checked={product === "nenhum"}
            onChange={() => set("nenhum")}
          />
          Nenhum
        </label> */}

        {/* Lista de produtos */}
        <div className="mt-6 space-y-6 scrollbar-hide" style={{ maxHeight: '55vh', overflow: 'scroll' }}>
          {products.filter((item: any) => item.name?.includes(search)).map((prod, index) => (
            <label
              key={index}
              className="flex items-center gap-3 cursor-pointer text-gray-700"
            >
              <input
                type="radio"
                name="produto"
                checked={product?._id === prod._id}
                onChange={() => setProduct(prod)}
              />
              {prod.name}
            </label>
          ))}
        </div>

        {/* Footer */}
        <div className="flex justify-between mt-2 pb-6 " style={{ position: 'absolute', bottom: 0, right: 20, left: 20 }}>
          <button onClick={(e) => {
            setEtapa(0)
            setSearch('');
            setClientProducts([]);
          }} className="px-6 py-3 rounded-lg bg-blue-600 text-white">
            Voltar
          </button>

          <button onClick={(e) => {
            if (product == null) {
              return;
            }
            setSearch('');

            setEtapa(2)

          }} className={"px-6 py-3 rounded-lg text-white " + (product == null ? 'opacity-70 cursor-not-allowed bg-gray-300' : 'bg-blue-500 hover:bg-blue-600')}>
            Próximo
          </button>
        </div>
      </div>}

      {etapa == 2 && <div className="bg-white w-1/2 h-full rounded-xl shadow-lg p-6 overflow-y-auto relative">

        {/* HEADER */}
        <div className="flex justify-between items-center">
          <h2 className="text-2xl font-bold">Novo agendamento</h2>
          <button onClick={onClose} className="text-gray-600 text-xl">✕</button>
        </div>

        {/* Título */}
        <h3 className="text-center text-xl font-semibold mt-4">Tipo de fluxo</h3>
        <p className="text-center text-gray-500">
          Selecione um fluxo para continuar
        </p>

        {/* Barra de progresso */}
        <div className="flex items-center justify-center gap-2 mt-6">
          <div className="h-1 w-20 bg-blue-500 rounded-full"></div>
          <div className="h-1 w-20 bg-blue-500 rounded-full"></div>
          <div className="h-1 w-20 bg-blue-500 rounded-full"></div>
          <div className="h-1 w-20 bg-gray-200 rounded-full"></div>
          <div className="h-1 w-20 bg-gray-200 rounded-full"></div>
          <div className="h-1 w-20 bg-gray-200 rounded-full"></div>
          <div className="h-1 w-20 bg-gray-200 rounded-full"></div>

        </div>

        {/* Opções */}
        <div className="mt-8 space-y-8">

          {/* Guiado */}
          <label className="flex items-start gap-3 cursor-pointer">
            <input
              type="radio"
              name="fluxo"
              checked={fluxo === "guiado"}
              onChange={() => setFluxo("guiado")}
              className="mt-1"
            />
            <div>
              <p className="font-medium">Guiado</p>
              <p className="text-gray-500 text-sm">
                Siga a ordem predefinida de reuniões do sistema
              </p>
            </div>
          </label>

          {/* Linha divisória */}
          <hr className="border-gray-200" />

          {/* Livre */}
          <label className="flex items-start gap-3 cursor-pointer">
            <input
              type="radio"
              name="fluxo"
              checked={fluxo === "livre"}
              onChange={() => setFluxo("livre")}
              className="mt-1"
            />
            <div>
              <p className="font-medium">Livre</p>
              <p className="text-gray-500 text-sm">
                Você define manualmente cada reunião
              </p>
            </div>
          </label>
        </div>

        {/* Footer */}
        <div className="flex justify-between mt-2 pb-6 " style={{ position: 'absolute', bottom: 0, right: 20, left: 20 }}>
          <button onClick={(e) => {
            setSearch('');

            setEtapa(1)
          }} className="px-6 py-3 rounded-lg bg-blue-600 text-white">
            Voltar
          </button>

          <button onClick={(e) => {
            if (product == null) {
              return;
            }
            setSearch('');

            if(fluxo=='guiado' && activities.length>0){
              // setAc
              let actual=activities[0]
              activities.map((item,index)=>{
                if(clients_products.filter((item) => item.productId == product._id)[0]?.phases?.includes(item._id)){
                  if(index==activities.length-1){
                    actual=item;
                  }
                  else{
                    actual=activities[index+1];
                  }
                }
              })
              setActivity(actual)

            }


            

            setEtapa(3)

          }} className="px-6 py-3 rounded-lg bg-blue-600 text-white">
            Próximo
          </button>
        </div>
      </div>}
      {etapa == 3 && <div className="bg-white w-1/2 h-[90vh] rounded-xl shadow-xl flex flex-col relative">

        {/* HEADER */}
        <div className="flex justify-between items-center p-6 border-b">
          <h2 className="text-xl font-semibold">Novo agendamento</h2>

          <div className="flex gap-3">
            {/* <button className="p-2 bg-gray-100 rounded-lg">
              <Eye className="w-5 h-5" />
            </button> */}
            <button className="p-2 bg-gray-100 rounded-lg" onClick={onClose}>
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>

        {/* TÍTULO */}
        <div className="text-center mt-4">
          <h3 className="text-lg font-semibold">Atividades ({clients_products.filter((item) => item.productId == product._id)[0]?.phases?.length ?? '0'}/{activities.length})</h3>
          <p className="text-sm text-gray-500">Selecione uma atividade para continuar</p>
        </div>

        {/* PROGRESSO */}
        <div className="flex items-center justify-center gap-2  p-6 ">
          <div className="h-1 w-20 bg-blue-500 rounded-full"></div>
          <div className="h-1 w-20 bg-blue-500 rounded-full"></div>
          <div className="h-1 w-20 bg-blue-500 rounded-full"></div>
          <div className="h-1 w-20 bg-blue-500 rounded-full"></div>
          <div className="h-1 w-20 bg-gray-200 rounded-full"></div>
          <div className="h-1 w-20 bg-gray-200 rounded-full"></div>
          <div className="h-1 w-20 bg-gray-200 rounded-full"></div>

        </div>

        {/* INPUT BUSCA */}
        <div className="px-6">
          <input
            type="text"
            placeholder="pesquise por nome ou whatsapp"
            className="w-full border rounded-lg px-4 py-2 text-gray-600"
          />
        </div>

        {/* LISTA */}
        <div className="flex-1 overflow-y-auto mt-4 px-6 space-y-4 pb-6">

          {activities.filter((item: any) => item.name?.includes(search)).map((item, index) => (
            <div key={index} className="flex justify-between items-center">
              <label className="flex items-center gap-3 cursor-pointer">
                <input
                  type="radio"
                  name="atividade"
                  checked={activity?._id === item._id}
                  onChange={() => setActivity(item)}
                  className="h-4 w-4 text-blue-600"
                />
                <span className="text-gray-800">{item.name}</span>
              </label>

              {/* ÍCONES */}
              {clients_products.filter((item) => item.productId == product._id)[0]?.phases?.includes(item._id) ? (
                <Check className="text-blue-600 w-5 h-5" />
              ) : (
                <Square className="text-gray-500 w-5 h-5" />
              )}
            </div>
          ))}

        </div>

        {/* FOOTER */}
        <div className="flex justify-between mt-2 pb-6 " style={{ position: 'absolute', bottom: 0, right: 20, left: 20 }}>
          <button
            onClick={(e) => {
              setSearch('');
              setActivity(null);

              setEtapa(2)
            }}
            className="px-8 py-3 bg-blue-600 text-white font-semibold rounded-lg"
          >
            Voltar
          </button>

          <button
            onClick={async(e) => {
              if (activity == null) {
                return;
              }
              let schedules = await (await fetch(API_URL + '/appointments/schedules/' + selecionado+'/'+activity.appointment?._id+'/all', {
              headers: {
                "Authorization": localStorage.getItem('token'),
                "Accept": "application/json"
              }
            })).json()

            let schedules_user = await (await fetch(API_URL + '/appointments/schedules/' + selecionado+'/'+activity.appointment?._id+'/'+user?._id, {
              headers: {
                "Authorization": localStorage.getItem('token'),
                "Accept": "application/json"
              }
            })).json()

            let hours:any = {};

            schedules_user.map((item:any)=>{
              hours[moment(item.date).format('YYYY-MM-DD HH:mm')+'-'+moment(item.date_end).format('YYYY-MM-DD HH:mm')] = true;
            })

            schedules.map((item:any)=>{
              hours[moment(item.date).format('YYYY-MM-DD HH:mm')+'-'+moment(item.date_end).format('YYYY-MM-DD HH:mm')] = true;
            })
            console.log(hours)
            
            setSchedules(schedules);
            setSchedulesUser(schedules_user);
            setHours(hours)



              setSearch('');

              setEtapa(4)
            }}
            className={"px-6 py-3 rounded-lg text-white " + (activity == null ? 'opacity-70 cursor-not-allowed bg-gray-300' : 'bg-blue-500 hover:bg-blue-600')}>
            Próximo
          </button>
        </div>

      </div>}
      {etapa == 4 && <div className="bg-white w-1/2 rounded-xl shadow-xl p-6 relative max-h-[90vh] overflow-y-auto">

        {/* HEADER */}
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-bold">Novo agendamento</h1>

          <div className="flex items-center gap-3">
            {/* <button className="w-10 h-10 rounded-lg border flex items-center justify-center">
              👁
            </button> */}

            <button
              className="w-10 h-10 rounded-lg border flex items-center justify-center"
              onClick={onClose}
            >
              ✕
            </button>
          </div>
        </div>

        {/* SUBTÍTULO */}
        <div className="text-center mt-6">
          <h2 className="text-xl font-semibold">Tipo de agenda</h2>
          <p className="text-gray-500 mt-1">Selecione uma agenda para continuar</p>
        </div>

        {/* PROGRESSO */}
        <div className="flex items-center justify-center gap-2 mt-6 ">
          <div className="h-1 w-20 bg-blue-500 rounded-full"></div>
          <div className="h-1 w-20 bg-blue-500 rounded-full"></div>
          <div className="h-1 w-20 bg-blue-500 rounded-full"></div>
          <div className="h-1 w-20 bg-blue-500 rounded-full"></div>
          <div className="h-1 w-20 bg-blue-500 rounded-full"></div>
          <div className="h-1 w-20 bg-gray-200 rounded-full"></div>
          <div className="h-1 w-20 bg-gray-200 rounded-full"></div>

        </div>

        {/* OPÇÕES */}
        <div className="mt-10 space-y-6">

          {/* PESSOAL */}
          <label className="flex items-start gap-3 cursor-pointer">
            <input
              type="radio"
              checked={selectedAgenda === "Pessoal"}
              onChange={() => setSelectedAgenda("Pessoal")}
              className="w-5 h-5"
            />
            <span className="text-lg font-medium">Pessoal</span>
          </label>

          <hr />

          {/* COMPARTILHADA */}
          {activity?.appointment?.type_appointment=='share' && activity?.appointment?.userPoolThirdShare?.users?.includes(user._id)  && <label className="flex items-start gap-3 cursor-pointer">
            <input
              type="radio"
              checked={selectedAgenda === "Compartilhada"}
              onChange={() => setSelectedAgenda("Compartilhada")}
              className="w-5 h-5"
            />
            <span className="text-lg font-medium">Compartilhada</span>
          </label>}

        </div>

        {/* BOTÕES */}
        <div className="flex justify-between mt-2 pb-6 " style={{ position: 'absolute', bottom: 0, right: 20, left: 20 }}>
          <button onClick={(e) => {
            setSearch('');

            setEtapa(3)
          }}
            className="bg-blue-600 text-white px-10 py-3 rounded-md text-lg font-medium">
            Voltar
          </button>

          <button onClick={(e) => {
            if (activity == null) {
              return;
            }
            setSearch('');
            if(selectedAgenda=='Pessoal'){
              setEtapa(6)
            }
            else{
              setEtapa(5)
            }
          }}
            className={"px-6 py-3 rounded-lg text-white " + (selectedAgenda == null ? 'opacity-70 cursor-not-allowed bg-gray-300' : 'bg-blue-500 hover:bg-blue-600')}>
            Próximo
          </button>
        </div>
      </div>}

      {etapa == 5 && <div className="bg-white w-1/2 max-h-[95vh] rounded-xl shadow-xl flex flex-col overflow-hidden" style={{ position: 'relative' }}>

        {/* HEADER */}
        <div className="border-b p-5 flex justify-between items-center">
          <h2 className="text-xl font-semibold">Novo agendamento</h2>

          <div className="flex items-center gap-3">
            {/* <button className="bg-gray-100 w-9 h-9 rounded-lg flex items-center justify-center">
              👁
            </button> */}
            <button onClick={onClose} className="bg-gray-100 w-9 h-9 rounded-lg flex items-center justify-center">
              ✕
            </button>
          </div>
        </div>

        {/* TÍTULO */}
        <div className="text-center p-4">
          <h1 className="text-xl font-semibold">Profissional</h1>
          <p className="text-gray-500">Selecione um profissional para continuar</p>
        </div>

        {/* ETAPAS (barra selecionada) */}
        <div className="flex items-center justify-center gap-2 p-6">
          <div className="h-1 w-20 bg-blue-500 rounded-full"></div>
          <div className="h-1 w-20 bg-blue-500 rounded-full"></div>
          <div className="h-1 w-20 bg-blue-500 rounded-full"></div>
          <div className="h-1 w-20 bg-blue-500 rounded-full"></div>
          <div className="h-1 w-20 bg-blue-500 rounded-full"></div>
          <div className="h-1 w-20 bg-blue-500 rounded-full"></div>
          <div className="h-1 w-20 bg-gray-200 rounded-full"></div>

        </div>

        {/* FILTROS */}
        <div className="grid grid-cols-2 gap-4 px-6 mt-5" onClick={(e) => {
          setOpenFilter(true)
        }}>
          <div className="border rounded-xl p-4">
            <p className="text-gray-500 text-sm">Setores</p>
            <p className="text-lg font-semibold">{selectedSetor == 'all' ? 'Todos' : selectedSetor?.name}</p>
          </div>

          <div className="border rounded-xl p-4">
            <p className="text-gray-500 text-sm">Áreas</p>
            <p className="text-lg font-semibold">{selectedArea == 'all' ? 'Todos' : selectedArea?.name}</p>
          </div>
        </div>

        {/* SEARCH */}
        <div className="flex px-6 mt-5">
          <input
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
            placeholder="pesquise pelo nome"
            className="w-full border rounded-xl px-4 py-3 outline-none"
          />
        </div>

        {/* LISTAGEM */}
        <div className="overflow-y-auto mt-4 px-6 pb-4" style={{ marginBottom: 90 }}>

          {/* OPÇÃO NENHUM */}


          {users.filter((item) => item.name?.includes(search)).filter((item: any) => {
            if (selectedSetor == 'all') return true;
            if (selectedArea == 'all') return item.sector == selectedSetor?.id;
            if (selectedRole == 'all') return item.sector == selectedSetor?.id && item.area == selectedArea?.id;
            else return item.sector == selectedSetor?.id && item.area == selectedArea?.id && (item.role == selectedRole?.id || item.role == selectedRole?.name);


          }).filter((item2:any)=>{
            return activity?.appointment?.userPoolWhoShare?.users?.includes(item2._id);
          }).map((p) => (
            <label
              key={p._id}
              className="flex items-center gap-4 py-4 border-b cursor-pointer"
            >
              <input
                type="radio"
                checked={selectedProfissional === p._id}
                onChange={() => setSelectedProfissional(p._id)}
                className="h-5 w-5"
              />

              <img src={p.photoUrl || 'https://microbiology.ucr.edu/sites/default/files/styles/form_preview/public/blank-profile-pic.png?itok=4teBBoet'} alt="" className="w-12 h-12 rounded-lg object-cover" />

              <div>
                <p className="font-medium">{p.name}</p>
                <p className="text-gray-500 text-sm">{roles.filter((item) => item._id == p.role || item.name == p.role)[0]?.name}</p>
              </div>
            </label>
          ))}
        </div>
        <FilterModal setSelectedArea={setSelectedArea} setSelectedRole={setSelectedRole}
          setSelectedSetor={setSelectedSetor}
          affiliates={affiliates}
          selectedArea={selectedArea}
          selectedRole={selectedRole}
          selectedSetor={selectedSetor}
          selectedProfissional={selectedProfissional}
          setSelectedProfissional={setSelectedProfissional}
          users={users}
          roles_all={roles}
          activity={activity}
          search={search}
          setSeach={setSearch}
          open={open_filter} onClose={() => setOpenFilter(false)} />

        {/* FOOTER BUTTONS */}
        <div className="flex justify-between mt-2 pb-6 " style={{ position: 'absolute', bottom: 0, right: 20, left: 20 }}>
          <button onClick={(e) => {
            setSearch('');
            setSelectedProfissional(null);
            setEtapa(4)
          }}
            className="px-8 py-3 bg-blue-600 text-white font-semibold rounded-lg">
            Voltar
          </button>

          <button onClick={async(e) => {
            if (selectedProfissional == null) {
              return;
            }
            let schedules_profissional= await (await fetch(API_URL + '/appointments/schedules/' + selecionado+'/'+activity.appointment?._id+'/'+selectedProfissional, {
              headers: {
                "Authorization": localStorage.getItem('token'),
                "Accept": "application/json"
              }
            })).json()

            let hours:any = {};

            schedules_profissional.map((item:any)=>{
              hours[moment(item.date).format('YYYY-MM-DD HH:mm')+'-'+moment(item.date_end).format('YYYY-MM-DD HH:mm')] = true;
            })

            schedules_user.map((item:any)=>{
              hours[moment(item.date).format('YYYY-MM-DD HH:mm')+'-'+moment(item.date_end).format('YYYY-MM-DD HH:mm')] = true;
            })

            schedules.map((item:any)=>{
              hours[moment(item.date).format('YYYY-MM-DD HH:mm')+'-'+moment(item.date_end).format('YYYY-MM-DD HH:mm')] = true;
            })

            console.log(hours)
            
            setSchedulesProfissional(schedules_profissional);
            setHours(hours)
            setSearch('');

            setEtapa(6)
          }}
            className={"px-6 py-3 rounded-lg text-white " + (selectedProfissional == null ? 'opacity-70 cursor-not-allowed bg-gray-300' : 'bg-blue-500 hover:bg-blue-600')}>
            Próximo
          </button>
        </div>
      </div>}
      {etapa == 6 && <div className="bg-white w-1/2 h-full rounded-xl shadow-lg p-6 overflow-y-auto relative">

        {/* HEADER */}
        <div className="flex justify-between items-center">
          <h2 className="text-2xl font-bold">Novo agendamento</h2>
          <button onClick={onClose} className="text-gray-600 text-xl">✕</button>
        </div>

        <h3 className="text-center text-xl font-semibold mt-4">Calendário</h3>
        <p className="text-center text-gray-500">Selecione uma data e horário</p>

        {/* Progress */}
        <div className="flex items-center justify-center gap-2 mt-6">
          <div className="h-1 w-20 bg-blue-500 rounded-full"></div>
          <div className="h-1 w-20 bg-blue-500 rounded-full"></div>
          <div className="h-1 w-20 bg-blue-500 rounded-full"></div>
          <div className="h-1 w-20 bg-blue-500 rounded-full"></div>
          <div className="h-1 w-20 bg-blue-500 rounded-full"></div>
          <div className="h-1 w-20 bg-blue-500 rounded-full"></div>
          <div className="h-1 w-20 bg-blue-500 rounded-full"></div>

        </div>

        {/* Navegação do calendário */}
        <div className="flex items-center justify-center mt-6 gap-4 text-lg font-semibold">
          <button onClick={() => mudarMes(-1)} className="px-3 py-1 rounded-lg bg-gray-100">{"<"}</button>
          <span>{meses[mesAtual]} - {anoAtual}</span>
          <button onClick={() => mudarMes(1)} className="px-3 py-1 rounded-lg bg-gray-100">{">"}</button>
        </div>

        {/* Cabeçalho dos dias */}
        <div className="grid grid-cols-7 text-center mt-4 text-gray-500 font-medium">
          {["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"].map(d => (
            <div key={d}>{d}</div>
          ))}
        </div>

        {/* Dias do mês */}
        <div className="grid grid-cols-7 gap-2 mt-2 text-center">
          {semanas.map((semana, i) =>
            semana.map((dia, j) => (
              <div key={`${i}-${j}`}>
                {dia ? (
                  <button
                    onClick={(e) => {
                      if (activity?.appointment?.weekDayAvailability[['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'][j]] == false) {
                        return;
                      }
                      if(dia.toString().length==1){
                        dia='0'+dia;
                      }
                      console.log(dia)
                      setDayCalendar({ dia, dia_semana: j, mes: mesAtual + 1, ano: anoAtual })
                      setTime(null);
                    }}
                    disabled={activity?.appointment?.weekDayAvailability[['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'][j]] == false} className={"w-full py-2 border rounded-lg " + (activity?.appointment?.weekDayAvailability[['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'][j]] == true ? "hover:bg-blue-100" : "bg-gray-300") + (dayCalendar?.dia == dia && dayCalendar?.mes == mesAtual + 1 ? " bg-blue-400" : "")}>
                    {dia}
                  </button>
                ) : (
                  <div className="w-full py-2"></div>
                )}
              </div>
            ))
          )}
        </div>
        <div style={{marginTop:15,marginBottom:15}}>
          <div className="flex align-center">
          <div style={{width:25,height:25,marginRight:10}} className="bg-gray-300">
            
          </div>
          <span>Dia indisponível</span>
          </div>
          <div className="flex align-center" style={{marginTop:5}}>

          <div style={{width:25,height:25,marginRight:10}} className="bg-blue-400">
            
          </div>
          <span>Dia selecionado</span>
          </div>
          <div className="flex align-center" style={{marginTop:5}}>

          <div style={{width:25,height:25,marginRight:10,border:'1px solid grey'}} className="bg-white-400">
            
          </div>
          <span>Dia disponível</span>
          </div>

        </div>

        {/* Seção de horários */}
        {dayCalendar != null && <div className="mt-10">
          <h4 className="text-center font-semibold text-gray-600">{["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"][dayCalendar?.dia_semana]} - {dayCalendar?.dia}/{dayCalendar?.mes}/{dayCalendar?.ano}</h4>

          {/* <div className="flex gap-4 mt-6 items-center">
            <input className="border p-3 rounded-lg w-1/2" type="time" />
            <input className="border p-3 rounded-lg w-1/2" type="time" />
            <button className="bg-blue-600 text-white px-4 py-3 rounded-lg text-lg">+</button>
          </div> */}

          {/* Lista de horários adicionados */}
          <div className="grid grid-cols-2 gap-6 mt-10">
            {activity?.appointment?.timeBlocks?.filter((item)=>{
              console.log(item.day,['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'][dayCalendar?.dia_semana])
             return item.day==['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'][dayCalendar?.dia_semana]
}).map((item3:any,id3)=>(
            gerarReunioes(item3.startTime,item3.endTime,activity?.appointment.intervalMinutes).map((h, i) => (
              hours[dayCalendar?.ano+'-'+dayCalendar?.mes+'-'+dayCalendar?.dia+' '+h.inicio+'-'+dayCalendar?.ano+'-'+dayCalendar?.mes+'-'+dayCalendar?.dia+' '+h.fim]==undefined? <div key={i+"+"+id3} onClick={(e)=>{
                setTime({...h,...dayCalendar})
              }} key={i} className="flex gap-4 items-center col-span-2" style={{border:timeSelect?.day==dayCalendar?.day && timeSelect?.inicio==h.inicio && timeSelect?.fim==h.fim?'1px solid blue': '1px solid lightgrey',borderRadius:10,padding:10,cursor:'pointer'}}>
                <div onClick={(e)=>{
                setTime({...h,...dayCalendar})
              }}  className="border p-3 rounded-lg w-1/2" disabled type="time" defaultValue={h.inicio} >
                {h.inicio}
                </div>
                <div onClick={(e)=>{
                setTime({...h,...dayCalendar})
              }}  className="border p-3 rounded-lg w-1/2" disabled type="time" defaultValue={h.fim}>
                {h.fim}
                </div>
                {/* <button className="text-gray-400 hover:text-red-500 text-xl">🗑</button> */}
              </div>:<></>
            ))
            ))}

           

          </div>
           {activity?.appointment?.timeBlocks?.filter((item)=>{
              console.log(item.day,['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'][dayCalendar?.dia_semana])
             return item.day==['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'][dayCalendar?.dia_semana]
}).map((item3:any,id3)=>(
            gerarReunioes(item3.startTime,item3.endTime,activity?.appointment.intervalMinutes).length)).reduce((accumulator, currentValue) => {
  return accumulator + currentValue;
}, 0)==0 && <p style={{textAlign:'center'}}>Nenhum horário encontrado</p>}
        </div>}

        {/* Footer */}
        {loadingSave==false ? <div className="flex justify-between mt-10 pb-6">
          <button onClick={()=>{
            setTime(null);
            setSearch('');
            if(selectedAgenda=='Pessoal'){
              setEtapa(4);
            }
            else{

              setEtapa(5)
            }
          }} className="px-6 py-3 rounded-lg bg-blue-600 text-white">Voltar</button>
          <button onClick={(e)=>{
            saveSchedule(null)
          }} 
            className={"px-6 py-3 rounded-lg text-white " + (timeSelect == null ? 'opacity-70 cursor-not-allowed bg-gray-300' : 'bg-blue-500 hover:bg-blue-600')}>
          Agendar</button>
        </div>:<div className="flex justify-center mt-10 pb-6">
            <CircularProgress />
          </div>}
      </div>}
    </div>
  );
}
